import React from "react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
    return (
        <footer id={"about"} className="bg-dark text-white py-4 mt-5">
            <div className="container">
                <div className="row">

                    <div className="col-md-3 mb-3">
                        <h5>Developer Information</h5>
                        <p>Name: Sabir Sheikh</p>
                        <p>Contact: +91 8830859061</p>
                        <p>Email: sabirsheikh199@gmail.com</p>
                    </div>

                    {/* About Us Section */}
                    <div className="col-md-3 mb-3">
                        <h5>About Us</h5>
                        <p>
                            We provide the best services to connect local shops with customers.
                            Discover the best products and services in your city.
                        </p>
                    </div>

                    <div className="col-md-3 mb-3">
                        <h5>Follow Us</h5>
                        <a href="https://facebook.com" className="text-white d-block mb-2"><FaFacebook /> Facebook</a>
                        <a href="https://twitter.com" className="text-white d-block mb-2"><FaTwitter /> Twitter</a>
                        <a href="https://instagram.com" className="text-white d-block"><FaInstagram /> Instagram</a>
                    </div>

                    {/* Developer Info & Contact */}
                    <div className="col-md-3 mb-3">
                        <h5>Get in Touch</h5>
                        <p>Contact: +91  9689655143</p>
                        <p>Email: pravinhote1991@gmail.com</p>
                    </div>

                </div>

                {/* Copyright */}
                <div className="text-center mt-3">
                    <p>&copy; {new Date().getFullYear()} OneTouch. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
